import React from "react";
import { Checkbox, Box, Text } from "@mantine/core";

interface CategoryCheckboxProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const CategoryCheckbox: React.FC<CategoryCheckboxProps> = ({
  label,
  checked,
  onChange,
}) => (
  <Box py={12} mt={8}>
    <Checkbox
      label={
        <Text size="sm" weight={400} color="dark">
          {label}
        </Text>
      }
      checked={checked}
      onChange={(event) => onChange(event.currentTarget.checked)}
      styles={{
        label: {
          paddingLeft: "16px",
        },
      }}
    />
  </Box>
);

export default CategoryCheckbox;
